import React, { useState } from 'react';
import { Card, CardContent } from './ui/card';
import { Button } from './ui/button';
import { Copy, Check } from 'lucide-react';

export const TextReport = ({ text, title = "Day's Insights" }) => {
  const [copied, setCopied] = useState(false);
  if (!text) return null;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (e) {
      const ta = document.createElement('textarea');
      ta.value = text;
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  return (
    <Card data-testid="text-report-card">
      <CardContent className="pt-5">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-semibold text-slate-800">📋 {title}</h3>
          <Button size="sm" variant="outline" onClick={handleCopy} data-testid="copy-report-btn">
            {copied ? <Check className="w-4 h-4 mr-1.5 text-green-600" /> : <Copy className="w-4 h-4 mr-1.5" />}
            {copied ? 'Copied!' : 'Copy Report'}
          </Button>
        </div>
        <pre
          className="whitespace-pre-wrap font-sans text-[15px] leading-relaxed text-slate-700 bg-slate-50 border border-slate-200 rounded-xl p-5"
          data-testid="text-report-body"
        >
          {text}
        </pre>
      </CardContent>
    </Card>
  );
};

export default TextReport;
